import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import SisLoader from "../../../../../widgets/loader";
import { ErrorToast, SuccessToast } from "../../../../../widgets/AppToast";
import AddLpgCargoCompressorModal from "../../components/CargoCraneCom/AddLpgCargoCompressorModal";
import LpgCargoCompressorTable from "../../components/CargoCraneCom/LpgCargoCompressorRow";

function LpgCargoCompressor({ id, onSuccess }) {
  const [loader, set_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [responseData, setResponseData] = useState({});
  const [errors, set_errors] = useState({});

  // List LPG Cargo Compressor API
  const listLpgCompressorData = () => {
    const formData = new FormData();
    formData.append("ship_id", id);
    try {
      post(ApiURL.list_lpg_cargo_compressor_details, formData).then((res) => {
        if (res?.status === true) {
          setFilteredData(res?.lpg_cargo_parameters_data || []);
        }
      });
    } catch (error) {
      console.error("Error fetching LPG Cargo Compressor list:", error);
    }
  };

  useEffect(() => {
    listLpgCompressorData();
  }, []);

  // Add LPG Cargo Compressor API
  const addLpgCompressorData = (data) => {
    set_loader(true);
    try {
      const formData = new FormData();
      formData.append("ship_id", id);
      formData.append("lpg_name", data?.compressor_name);
      formData.append("lpg_model", data?.compressor_model);
      formData.append("lpg_maker", data?.compressor_maker);
      formData.append("machinery_type", data?.machinery_dropdown);
      formData.append("selected_parameters", JSON.stringify(data?.selectedParams));
      formData.append("other_parameters", JSON.stringify(data?.customParams));

      post(ApiURL.add_lpg_cargo_compressor_details, formData).then((res) => {
        if (res?.status === true) {
          SuccessToast("LPG Cargo Compressor Details Saved!", "Details Successfully Added!!");
          listLpgCompressorData();
          setIsModalOpen(false);
          if (onSuccess) onSuccess();
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
        set_loader(false);
      });
    } catch (error) {
      set_loader(false);
      console.error("Error occurred while adding LPG Cargo Compressor details:", error);
    }
  };
   // Update LPG Cargo Compressor API
  const updateLpgCompressorData = (data) => {
    set_loader(true);
    try {
      const formData = new FormData();
      formData.append("id", data?.id);
      formData.append("ship_id", id);
      formData.append("lpg_name", data?.compressor_name);
      formData.append("lpg_model", data?.compressor_model);
      formData.append("lpg_maker", data?.compressor_maker);
      formData.append("machinery_type", data?.machinery_dropdown);
      formData.append("selected_parameters", JSON.stringify(data?.selectedParams));
      formData.append("other_parameters", JSON.stringify(data?.customParams));
      formData.append("request_type", "add-edit");

      post(ApiURL.edit_view_lpg_cargo_compressor_details, formData).then((res) => {
        if (res?.status === true) {
          SuccessToast("Success", res?.message || "Details Updated Successfully!");
          setIsModalOpen(false);
          listLpgCompressorData();
          if (onSuccess) onSuccess();
          set_errors({});
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
        set_loader(false);
      });
    } catch (error) {
      console.error("Error occurred while updating LPG Cargo Compressor details:", error);
      set_loader(false);
    }
  };

  const VIEW_API = (data) => {
    try {
      const formData = new FormData();
      formData.append("ship_id", id);
      formData.append("id", data?.id);
      formData.append("request_type", "view");
      post(ApiURL.edit_view_lpg_cargo_compressor_details, formData).then((res) => {
        if (res?.status === true) {
          setResponseData(res?.cargo_lpg_parameters_data);
          setIsModalOpen(true);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } catch (error) {
      console.error("Error while viewing LPG Cargo Compressor details:", error);
    }
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <h3 style={{ marginTop: "15px", marginBottom: "15px" }}>
          LPG Cargo Compressor Information
        </h3>
        <Button
          type="primary"
          onClick={() => {
            setIsModalOpen(true);
            setResponseData({});
          }}
          style={{ position: "absolute", right: "0px", top: "-10px" }}
        >
          Add LPG Cargo Compressor
        </Button>
        <AddLpgCargoCompressorModal
          visible={isModalOpen}
          onOk={(data) => {
            if (responseData?.id) {
              updateLpgCompressorData({ ...data, id: responseData.id });
            } else {
              addLpgCompressorData(data);
            }
          }}
          onCancel={() => {
            setIsModalOpen(false);
            setResponseData({});
            set_errors({});
          }}
          responseData={responseData}
          errors={errors}
        />
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {filteredData?.length > 0 ? (
              <LpgCargoCompressorTable data={filteredData} onEdit={(row) => VIEW_API(row)} />
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
}

export default LpgCargoCompressor;
